import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  inject,
  OnDestroy,
  OnInit,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ActivatedRoute } from '@angular/router';

import { OrdersParserService } from 'src/app/core/services/orders-parser';
import * as Orders from '../../domain';
import { TablePageComponent } from './table-page/table-page.component';
import { ViewOrderComponent } from './view-order/view-order.component';

@Component({
  selector: 'app-orders',
  templateUrl: './orders-table.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatProgressSpinnerModule, TablePageComponent, ViewOrderComponent],
})
export class OrdersComponent implements OnInit, OnDestroy {
  /** True while the table "View more" detail is shown (hide shell Orders header + view toggle). */
  @Output() tableViewDetailActive = new EventEmitter<boolean>();
  @Output() tableCsvDataChange = new EventEmitter<Orders.OrderCsvDataRow[]>();

  orders: Orders.Order[] = [];

  selectedOrder: Orders.Order = null;

  otherSiteServices: Orders.Order[] = [];

  loading: boolean = true;

  noOrders: boolean = false;

  private route = inject(ActivatedRoute);

  private cdr = inject(ChangeDetectorRef);

  private service = inject(OrdersParserService);

  ngOnInit(): void {
    this.loadOrders();
  }

  ngOnDestroy(): void {
    this.loading = true;
    this.tableViewDetailActive.emit(false);
  }

  private checkOrderId(): void {
    const orderId = this.route.snapshot.paramMap.get('orderId');
    if (!orderId) return;
    const filteredOrder = this.orders.filter((order) => order.id === orderId);
    if (filteredOrder.length > 0) {
      const firstFilteredOrder = filteredOrder[0];
      this.selectedOrder = firstFilteredOrder;
      this.otherSiteServices = this.getOtherSiteServices(firstFilteredOrder);
    }
    this.cdr.detectChanges();
  }

  private loadOrders(): void {
    // False below is to denote that we are not calling getOrders from the orders-table page
    this.service.getOrders(false)?.subscribe((orders) => {
      if (!orders) {
        this.noOrders = true;
      } else if (orders.length === 0) {
        this.noOrders = true;
      }
      this.orders = orders;
      this.checkOrderId();
      this.loading = false;
      this.tableViewDetailActive.emit(!!this.selectedOrder);
      this.cdr.detectChanges();
    });
  }

  open(order: Orders.Order): void {
    this.tableViewDetailActive.emit(true);
    this.selectedOrder = order;
    this.otherSiteServices = this.getOtherSiteServices(order);
    this.loading = true;
    this.cdr.detectChanges();
    window.setTimeout(() => {
      this.loading = false;
      this.cdr.detectChanges();
    }, 100);
  }

  getOtherSiteServices(order: Orders.Order): Orders.Order[] {
    return this.orders.filter((o: Orders.Order) => o.address === order.address);
  }

  goBack(): void {
    this.loading = true;
    this.cdr.detectChanges();
    window.setTimeout(() => {
      this.selectedOrder = null;
      this.otherSiteServices = [];
      this.loading = false;
      this.tableViewDetailActive.emit(false);
      this.cdr.detectChanges();
    }, 100);
  }

  onTableCsvDataChange(data: Orders.OrderCsvDataRow[]): void {
    this.tableCsvDataChange.emit(data);
  }
}
